var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "picture",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9819",
    "data-name": "Trac\\xE9 9819",
    d: "M7.427,12.243a2,2,0,0,0-2.829,0L.038,16.8a3.327,3.327,0,0,0,3.308,3.083h9.333a3.312,3.312,0,0,0,1.835-.555Z",
    transform: "translate(-0.013 -3.886)",
    fill: "#b5b5b5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 1.733,
    cy: 1.733,
    r: 1.733,
    transform: "translate(10.267 2.667)",
    fill: "#b5b5b5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9820",
    "data-name": "Trac\\xE9 9820",
    d: "M3.334.8A2.541,2.541,0,0,0,.8,3.333V9.126L3.077,6.849A4.107,4.107,0,0,1,6,5.638H6A4.106,4.106,0,0,1,8.923,6.849l6.241,6.241a2.52,2.52,0,0,0,.036-.423V3.334A2.541,2.541,0,0,0,12.667.8H3.334m0-.8h9.333A3.337,3.337,0,0,1,16,3.333v9.333a3.313,3.313,0,0,1-.555,1.835L8.357,7.415a3.333,3.333,0,0,0-4.715,0L0,11.057V3.333A3.337,3.337,0,0,1,3.333,0Z",
    fill: "#b5b5b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.d91f9c2a390c3e1c8c9c214cd8cb7df2.svg";
export { ForwardRef as ReactComponent };